class Auth {
  /**
   * Authenticate a user. Save a token string in Local Storage
   *
   * @param {string} token
   */
  static authenticateUser(username, client, token) {
    localStorage.setItem("onevuusername", username);
    localStorage.setItem("client", client);
    localStorage.setItem("token", token);
  }

  /**
   * Check if a user is authenticated - check if a token is saved in Local Storage
   *
   * @returns {boolean}
   */
  static isUserAuthenticated() {
    return localStorage.getItem("token") !== null;
  }

  /**
   * Deauthenticate a user. Remove a token from Local Storage.
   *
   */
  static deauthenticateUser() {
    localStorage.removeItem("token");
    localStorage.removeItem("client");
    localStorage.removeItem("username");
  }

  /**
   * Get a token value.
   *
   * @returns {string}
   */

  static getToken() {
    return localStorage.getItem("token");
  }

  static getUserName() {
    return localStorage.getItem("onevuusername");
  }

  static getClient() {
    return localStorage.getItem("client");
  }

  static updateUserInformation(userData) {
    // let availableModules = this.getRolesDetails(userData['roles']);
    // let moduleSelected = this.getModulePriority(userData['module']);
    // localStorage.setItem('theme', userData.userTheme);    
    //localStorage.setItem('module', userData['module']);
    //localStorage.setItem('selectedModule', moduleSelected);
    localStorage.setItem('setupTime', new Date().getTime());
    //localStorage.setItem('loggedInUserFullName', userData.fullName);
  }

  static updateUserConfigInformation(configurationDetails) {
    localStorage.setItem(
      'incidentAutoRefreshTime',
      configurationDetails['auto.refresh.incident.list.time.in.minutes'] * 60000
    );
    localStorage.setItem(
      'problemAutoRefreshTime',
      configurationDetails['auto.refresh.problem.list.time.in.minutes'] * 60000
    );
    localStorage.setItem(
      'incidentAssignGrpMand',
      configurationDetails['incident.assigned.to.group.mandatory']
    );
    localStorage.setItem(
      'problemAssignGrpMand',
      configurationDetails['problem.assigned.to.group.mandatory']
    );
    localStorage.setItem(
      'systemTimeOutConfig',
      configurationDetails['session.auto.closure.time.in.minutes']
    );
    localStorage.setItem(
      'systemWarningTimeOutConfig',
      configurationDetails['session.auto.closure.warning.time.in.minutes']
    );
    localStorage.setItem(
      'attachmentSize',
      configurationDetails['total.attachment.size.kb'] * 1000
    );
    localStorage.setItem(
      'maxNotificationLimit',
      configurationDetails['max.limit.for.notification.recipients']
    );
    localStorage.setItem(
      'saveCustomeReportSelection',
      configurationDetails['save.custom.report.template']
    );
    localStorage.setItem(
      'profileImageSize',
      configurationDetails['profile.photo.size.limit'] * 1000
    );
    localStorage.setItem(
      'enableWebChat',
      configurationDetails['web.chat.enable']
    );
    localStorage.setItem(
      'showLocation',
      configurationDetails['incident.location.variable.visible']
    );
  }

  static getModulePriority(availbleModules) {
    let selectedModule = '';
    if (availbleModules.includes('IM')) {
      selectedModule = 'IM';
    } else if (availbleModules.includes('PM')) {
      selectedModule = 'PM';
    } else if (availbleModules.includes('CM')) {
      selectedModule = 'CM';
    } else if (availbleModules.includes('KM')) {
      selectedModule = 'KM';
    } else if (availbleModules.includes('KM')) {
      selectedModule = 'KM';
    } else if (availbleModules.includes('CFG_M')) {
      selectedModule = 'CFG_M';
    }

    return selectedModule;
  }

  static getRolesDetails(roleDetails) {
    let imRoles = [];
    let pmRoles = [];
    let cmRoles = [];
    let kmRoles = [];
    let modules = [];
    let umRoles = [];
    let ciRoles = [];

    roleDetails.map((eachRoleDetails) => {
      imRoles.push(eachRoleDetails['roleName']);
      cmRoles.push(eachRoleDetails['roleName']);
      kmRoles.push(eachRoleDetails['roleName']);
      pmRoles.push(eachRoleDetails['roleName']);
      umRoles.push(eachRoleDetails['roleName']);
      ciRoles.push(eachRoleDetails['roleName']);

    });

    if (imRoles.length > 0) {
      imRoles = [...new Set(imRoles)];
      localStorage.setItem('imRoles', imRoles);
    }

    if (pmRoles.length > 0) {
      pmRoles = [...new Set(pmRoles)];
      localStorage.setItem('pmRoles', pmRoles);
    }

    if (cmRoles.length > 0) {
      cmRoles = [...new Set(cmRoles)];
      localStorage.setItem('cmRoles', cmRoles);
    }

    if (kmRoles.length > 0) {
      kmRoles = [...new Set(kmRoles)];
      localStorage.setItem('kmRoles', kmRoles);
    }

    if (umRoles.length > 0) {
      umRoles = [...new Set(umRoles)];
      localStorage.setItem('umRoles', umRoles);
    }

    if (ciRoles.length > 0) {
      ciRoles = [...new Set(ciRoles)];
      localStorage.setItem('ciRoles', ciRoles);
    }

    return [...new Set(modules)];
  }

}

export default Auth;
